import React from "react";
import markerIcon from '../../../../assets/icons/marker.svg';

const GREY_FILTER = '[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(0%)_saturate(0%)_brightness(90%)]';

const ResultItem = ({ title, categoryName, subCategoryName, categoryId, subCategoryId, location, onClose }) => {
    const truncate = (text, max = 55) =>
        text && text.length > max ? text.slice(0, max) + '…' : text;

    return (
        <a
            href={`/category/${categoryName}/${subCategoryName}/${categoryId}/${subCategoryId}`}
            onClick={onClose}
            className="
                flex flex-col gap-1.5 p-3 rounded-xl no-underline
                bg-[#F9F9F9] hover:bg-[#e8f5ea]
                border border-transparent hover:border-[#147F26]/20
                transition-all duration-150 group
            "
        >
            {/* Title */}
            <p className="m-0 text-[14px] font-semibold text-[#222222] leading-snug line-clamp-2 group-hover:text-[#147F26] transition-colors duration-150">
                {truncate(title)}
            </p>

            {/* Category breadcrumb */}
            <p className="m-0 text-[11px] text-[#939393] leading-none">
                {categoryName}{subCategoryName ? ` / ${subCategoryName}` : ''}
            </p>

            {/* Location */}
            {location && (
                <div className="flex items-center gap-1 mt-0.5">
                    <img src={markerIcon} alt="" width={11} height={11} className={GREY_FILTER} />
                    <span className="text-[11px] text-[#939393]">{location}</span>
                </div>
            )}
        </a>
    );
};

export default ResultItem;
